import '../App.css'
const Header =()=>{
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="App-header">
                    <p> Ethnus</p>
                </div>
            </div>
        </div>

    )
}
export default Header